import { RightOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import React from 'react';

function TemplatesSettings({ onOpen }) {
  return (
    <Flex className='expandable-link' onClick={onOpen} justify='space-between' align='center'>
      <p className='body1'>Modèles de messages</p>
      <Button type='text' size='large' className='btn-icon' icon={<RightOutlined />} />
    </Flex>
  );
}

export default TemplatesSettings;
